module.exports = __webpack_public_path__ + "static/img/122.9.39.66.57369385.png";